const showHide = (el, shouldShow) => {
  if (shouldShow) {
    $(el).loadingCurtain('show');
  } else {
    $(el).loadingCurtain('hide');
  }
};

export default {
  bind(el, binding) {
    showHide(el, binding.value);
  },
  update(el, binding) {
    showHide(el, binding.value);
  },
};
